import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    body {
        margin: 0;
        padding: 0;
        background: #0a0e27;
        box-sizing: border-box;
        font-family: 'Nunito', Helvetica, Sans-Serif !important;
    }

    .align-vertical {
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
    }

    .broker-binolla {
        height: 70px;
        width: 130px;
        border-radius: 5px;
        display: inline-block;
        font-size: 30px;
        color: #222222;
        margin-bottom: 30px;

        img {
            object-fit: contain;
            border-radius: 10px;
        }
    }

    .img-trading-modal {
        border-radius: 5px;
        display: inline-block;
        font-size: 30px;
        color: #222222;
        width: 90%;

        img {
            object-fit: contain;
            border-radius: 10px;
            width: 100%;
            max-width: 720px;
            max-height: 403px;
        }
    }

    .trading-modal {
        width: 50%;
        height: 62%;
    }

    .img-trading {
        height: 50px;
        width: 65px;
        border: 1px solid rgba(134, 136, 134, 0.63);
        border-radius: 5px;
        background: #f9f9ff;
        font-size: 30px;
        color: #222222;

        img {
            border-radius: 5px;
            object-fit: cover;
        }
    }

    .kep-login-facebook {
        text-transform: capitalize !important;
        background-color: transparent !important;
        border: none !important;
        padding: 0px !important;
        color: blue !important;
        font-size: 0.875rem !important;
    }

    .dropdown-item {
        cursor: pointer;
    }

    .btn-group-xs > .btn, .btn-xs {
        padding: 1px 5px !important;
        font-size: 12px !important;
        line-height: 1.5 !important;
        border-radius: 3px !important;
    }

    .swal-text {
        text-align: center;
    }

    .fa-1x {
        font-size: 20px;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    input:-webkit-autofill {
        background-color: #e0f7fa !important; /* Cor personalizada para o fundo */
        transition: background-color 5000s ease-in-out 0s; /* Para garantir que a cor não seja sobrescrita */
        color: white !important; /* Cor da fonte */
        -webkit-text-fill-color: white !important; /* Para garantir que o texto seja branco */
    }

    .card-balance {
        border: 3px solid rgba(0, 0, 0, 0.07);
        border-radius: 20px;
    }

    .text-black {
        color: #000 !important;
    }

    /*
     * Botões e inputs em pílula (mesma pegada do Control Zone / app mobile):
     * input com preenchimento sólido, sem borda em repouso (só no foco / erro)
     * e rótulo estático acima do campo. Classes repetidas pra vencer os
     * overrides com !important espalhados pelas páginas.
     */
    .MuiButton-root.MuiButton-root.MuiButton-root,
    .btn.btn.btn:not(.btn-link),
    .swal-button.swal-button {
        border-radius: 999px !important;
    }

    .btn-group > .btn.btn.btn,
    .input-group > .btn.btn.btn,
    .input-group-append > .btn.btn.btn,
    .input-group-prepend > .btn.btn.btn {
        border-radius: 0.35rem !important;
    }

    .form-control:not(textarea):not(.custom-select-multiple) {
        border-radius: 999px !important;
    }

    .MuiOutlinedInput-root.MuiOutlinedInput-root.MuiOutlinedInput-root {
        border-radius: 999px !important;
        background: rgba(255, 255, 255, 0.05);

        &.MuiInputBase-multiline,
        &.MuiOutlinedInput-multiline {
            border-radius: 16px !important;
        }

        .MuiOutlinedInput-notchedOutline {
            border-color: transparent !important;
            border-width: 1px !important;
            top: 0 !important;

            legend {
                display: none !important;
                width: 0 !important;
            }
        }

        &.Mui-focused .MuiOutlinedInput-notchedOutline {
            border-color: #00d4ff !important;
        }

        &.Mui-error .MuiOutlinedInput-notchedOutline {
            border-color: #ff6b6b !important;
        }
    }

    .MuiOutlinedInput-input.MuiOutlinedInput-input:not(.MuiAutocomplete-input) {
        &:not(.MuiInputBase-inputAdornedStart) {
            padding-left: 18px !important;
        }

        &:not(.MuiInputBase-inputAdornedEnd):not(.MuiSelect-select) {
            padding-right: 18px !important;
        }
    }

    .MuiAutocomplete-root .MuiOutlinedInput-root.MuiOutlinedInput-root.MuiOutlinedInput-root {
        padding-left: 14px !important;
    }

    .MuiFormControl-root > .MuiInputLabel-outlined.MuiInputLabel-outlined {
        position: static !important;
        transform: none !important;
        max-width: 100%;
        margin: 0 0 6px 4px;
        font-size: 0.78rem !important;
        font-weight: 600;
        line-height: 1.4;
        color: #b0b0b0 !important;
        pointer-events: auto;

        &.Mui-focused {
            color: #b0b0b0 !important;
        }

        &.Mui-error {
            color: #ff6b6b !important;
        }
    }

    /* Rótulo fora do campo: placeholder sempre visível, mesmo com o campo vazio */
    .MuiFormControl-root.MuiFormControl-root .MuiInputBase-input.MuiInputBase-input::placeholder {
        color: rgba(255, 255, 255, 0.38) !important;
        opacity: 1 !important;
    }
`;

export default GlobalStyle;
